import { PortfolioStatements } from "types/Statements";
import { createCustomAction } from "typesafe-actions";

const STATEMENTS_DATA_LOAD = "STATEMENTS/STATEMENTS_DATA_LOAD";
const STATEMENTS_DATA_LOAD_SUCCESS = "STATEMENTS/STATEMENTS_DATA_LOAD_SUCCESS";
const STATEMENTS_DATA_LOAD_FAIL = "STATEMENTS/STATEMENTS_DATA_LOAD_FAIL";

export const load = createCustomAction(STATEMENTS_DATA_LOAD, (type) => () => ({
  type,
}));

export const loadSuccess = createCustomAction(
  STATEMENTS_DATA_LOAD_SUCCESS,
  (type) => (data?: PortfolioStatements[]) => ({
    type,
    data,
  })
);

export const loadFail = createCustomAction(
  STATEMENTS_DATA_LOAD_FAIL,
  (type) => (error?: string) => ({
    type,
    error,
  })
);
